import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { addToCart, getCartCount } from "../../../utils/cartUtils";
import { TfiRulerAlt } from "react-icons/tfi";


import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowRight, FaStar, FaPlus, FaMinus } from "react-icons/fa";
import { LiaTimesSolid } from "react-icons/lia";

const Product4 = ({ data }) => {
  const [showPrev, setShowPrev] = useState(true);
  const [showNext, setShowNext] = useState(true);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [themeColor, setThemeColor] = useState("#0000ff");
  const swiperRef4 = useRef(null);
  const [commonSubCategoryAutoId, setCommonSubCategoryAutoId] = useState("");
  const [commonSubCategoryName, setCommonSubCategoryName] = useState("");
  // Quick View states
const [selectedProduct, setSelectedProduct] = useState(null);
const [quantity, setQuantity] = useState(1);
const [selectedSize, setSelectedSize] = useState(null);
const [selectedSizeId, setSelectedSizeId] = useState(null);
const [selectedSizePrice, setSelectedSizePrice] = useState(null);
// 🔹 Size chart
const [showSizeChart, setShowSizeChart] = useState(false);
const [chartImage, setChartImage] = useState(null);
const [chartImage2, setChartImage2] = useState(null);

// 🔹 Stock + marketing
const [selectedStock, setSelectedStock] = useState(null);
const [showStock, setShowStock] = useState(false);
const [randomStocks, setRandomStocks] = useState([]);
const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);

// 🔹 Messages
const [message, setMessage] = useState(null);


const prevRef = useRef(null);
const nextRef = useRef(null);
const clearMessage = () => {
  setTimeout(() => setMessage(null), 2000);
};

const darkenHexColor = (hex, percent) => {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) - 255 * percent;
  let g = ((num >> 8) & 0x00ff) - 255 * percent;
  let b = (num & 0x0000ff) - 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
};
const fetchSizeChart = async () => {
  if (showSizeChart) {
    setShowSizeChart(false);
    return;
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
      {
        admin_auto_id: sessionStorage.getItem("admin_auto_id"),
        app_type_id: sessionStorage.getItem("app_type_id"),
      }
    );

    if (res.data.status === "1" && res.data.getalldata?.length) {
      setChartImage(
        `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${res.data.getalldata[0].chart_image}`
      );
      setChartImage2(
        `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${res.data.getalldata[0].international_size_chart}`
      );
      setShowSizeChart(true);
    }
  } catch (err) {
    console.error("Size chart error", err);
  }
};


  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const adminId = sessionStorage.getItem("admin_auto_id");
        const appTypeId = sessionStorage.getItem("app_type_id");
        const accessToken = sessionStorage.getItem("accessToken");
        const response = await axios.post(
          "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_new_product_list",
          {
            admin_auto_id: adminId,
            app_type_id: appTypeId,
            component_auto_id: data._id,
            component_type: "Products",
            limit: 6,
            page_number: 1,
            customer_auto_id: accessToken || adminId,
          }
        );

        if (
          response.data.status === 1 &&
          Array.isArray(response.data.get_products_lists) &&
          response.data.get_products_lists.length > 0
        ) {
          setCommonSubCategoryAutoId(
            response.data.get_products_lists[0].sub_category_auto_id
          );
          setCommonSubCategoryName("Shop Now");
          const formattedProducts = response.data.get_products_lists.map((product) => ({
  id: product.product_auto_id,
  name: product.product_name,
  description: product.description || "",

  images: product.product_images?.length
    ? product.product_images.map(
        (img) =>
          `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
      )
    : ["https://placehold.co/600x400"],

  image: product.product_images?.length
    ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
    : "https://placehold.co/600x400",

  // ✅ REQUIRED FOR CART
  sizes: product.size_list || [],
  get_price_lists: product.get_price_lists || [],
  user_auto_id: product.user_auto_id,
  moq: product.moq || 1,

  offerPrice: product.final_product_price,
  actualPrice: product.product_price,
}));



          setProducts(formattedProducts);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [data._id]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  const handleViewAll = () => {
    navigate("/productlist", {
      state: {
        sub_cat_id: commonSubCategoryAutoId,
        subcategoryName: commonSubCategoryName,
      },
    });
  };
  const handleAddToCart = async () => {
  if (!sessionStorage.getItem("accessToken")) {
    alert("Please login to continue");
    return;
  }

  // Size validation
  if (selectedProduct.sizes?.length > 0 && !selectedSizeId) {
    alert("Please select a size");
    return;
  }

  const payload = {
    product_auto_id: selectedProduct.id,
    added_by_id: selectedProduct.user_auto_id, // ✅ REQUIRED
    cart_quantity: quantity,
    ...(selectedProduct.sizes?.length > 0 && {
      size: selectedSizeId,
      size_price: selectedSizePrice,
    }),
  };

  console.log("ADD TO CART PAYLOAD 👉", payload);

  try {
    const res = await addToCart(payload);
    await getCartCount();

    if (res?.status === "1") {
      // Reset states
      setSelectedProduct(null);
      setQuantity(1);
      setSelectedSize(null);
      setSelectedSizeId(null);
      setSelectedSizePrice(null);

      navigate("/cart");
    } else {
      alert(res?.message || "Failed to add to cart");
    }
  } catch (error) {
    console.error("Add to cart error:", error);
    alert(error.message || "Failed to add to cart");
  }
};







  if (loading || products.length === 0) return null;


  return (
    <>
      {/* 🖥️ Desktop View */}
      <div
        className={`hidden md:flex h-[600px] bg-cover bg-center items-center mx-2 rounded-lg mb-2 ${data.web_title_font}`}
        style={{
          backgroundImage: `url(https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${data.background_image})`,
          overflow: "hidden",
        }}
      >
        <div className="flex flex-col items-center justify-center w-1/4 p-4">
          <h2
            className="mb-2 text-5xl font-bold text-center"
            style={{ color: data.web_title_color }}
          >
            {data.title}
          </h2>

          <button
            className="flex items-center justify-center p-3 text-black bg-transparent border-2 rounded-full"
            onClick={handleViewAll}
          >
            <FaArrowRight />
          </button>
        </div>

       

        {/* Slider */}
        <div className="relative w-full md:w-3/4 overflow-hidden">

  {/* LEFT ARROW */}
  <button
    ref={prevRef}
    className={`absolute left-2 top-1/2 -translate-y-1/2 z-50
     
      p-3 rounded-full shadow-lg
      transition-all
      ${!showPrev ? "opacity-0 pointer-events-none" : "opacity-100"}
    `}
  >
    {/* <IoIosArrowDropleft size={26} /> */}
  </button>

  {/* SWIPER */}
  <Swiper
    ref={swiperRef4}
    modules={[Navigation]}
    spaceBetween={20}
    slidesPerView={3.5}
    breakpoints={{
      0: { slidesPerView: 1.5, spaceBetween: 10 },
      768: { slidesPerView: 2.5, spaceBetween: 15 },
      1024: { slidesPerView: 3.5, spaceBetween: 20 },
    }}
    onBeforeInit={(swiper) => {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
    }}
    onSlideChange={(swiper) => {
      setShowPrev(!swiper.isBeginning);
      setShowNext(!swiper.isEnd);
    }}
    navigation
  >
    {products.map((product) => (
      <SwiperSlide key={product.id} className="relative">

        {/* QUICK VIEW BUTTON */}
        <button
          className="absolute bottom-4 sm:bottom-16 left-1/2 -translate-x-1/2 z-50
            px-4 py-2 text-sm font-semibold text-white mb-6
            
            rounded-full shadow-lg
            transition-all duration-300
          "
           style={{
                      backgroundColor: themeColor,
                    }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSelectedProduct(product);
            setQuantity(1);
          }}
        >
          Quick View
        </button>

        {/* PRODUCT CARD */}
        <div className="bg-white rounded-xl overflow-hidden">
          <Link to={`/product-detail/${product.id}`}>
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-[450px] object-cover"
            />
          </Link>
          <div className="p-2 text-center">
            <h3 className="text-sm font-semibold truncate">{product.name}</h3>
            <span className="text-sm text-black">₹{product.offerPrice}</span>
          </div>
        </div>

      </SwiperSlide>
    ))}
  </Swiper>

  {/* RIGHT ARROW */}
  <button
    ref={nextRef}
    className={`absolute right-2 top-1/2 -translate-y-1/2 z-50
      
      p-3 rounded-full shadow-lg
      transition-all
      ${!showNext ? "opacity-0 pointer-events-none" : "opacity-100"}
    `}
  >
    {/* <IoIosArrowDropright size={26} /> */}
  </button>

</div>

      </div>

      {/* 📱 Mobile View */}
      <div className={`md:hidden mb-6 ${data.web_title_font}`}>
        {/* Background with title and button on top */}
        <div
          className="relative h-[550px] mt-4 bg-cover bg-center rounded-lg overflow-hidden"
          style={{
            backgroundImage: `url(https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${data.background_image})`,
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/40"></div>

          {/* Title and button */}
          <div className="absolute inset-0 flex flex-col items-center p-4 text-center z-10">
            <h2
              className="text-3xl font-bold mb-3 drop-shadow-lg text-white"
              style={{ color: data.web_title_color }}
            >
              {data.title}
            </h2>

            <button
              onClick={handleViewAll}
              className="flex items-center justify-center gap-2 text-white border-2 border-white rounded-full px-4 py-2 text-sm font-semibold hover:bg-white hover:text-black transition duration-300"
            >
              <span>Shop Now</span>
              <FaArrowRight />
            </button>
          </div>
          <div className="absolute bottom-6 left-0 w-full p-2 text-center block md:hidden z-20">
          <Swiper
            ref={swiperRef4}
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={1.5}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                
                <button
          className="absolute bottom-4  left-1/2 -translate-x-1/2 z-50
            px-2 py-1 text-sm font-semibold text-white mb-12
            
            rounded-full shadow-lg
            transition-all duration-300
          "
           style={{
                      backgroundColor: themeColor,
                    }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSelectedProduct(product);
            setQuantity(1);
          }}
        >
          Quick View
        </button>
                  <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                     <Link to={`/product-detail/${product.id}`}>
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-[320px] object-cover"
                    />
                    </Link>

                    <div className="p-2 text-center">
                      <h3 className="text-sm font-semibold truncate">
                        {product.name}
                      </h3>
                      <span className="text-sm text-black">
                        ₹{product.offerPrice}
                      </span>
                    </div>
                  </div>
                
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        </div>
      </div>
      {selectedProduct && (
             <div className="fixed inset-0 z-40 flex justify-end bg-opacity-30 backdrop-blur-sm">
               <div className="w-full sm:w-[500px] h-full bg-white shadow-lg transform transition-transform z-50 flex flex-col">
                 {/* Header with title and close button */}
                 <div className="flex items-center justify-between px-4 py-3">
                   <p
                     className="mb-0 text-lg font-bold text-black"
                     onClick={() => setSelectedProduct(null)}
                   >
                     CHOOSE OPTION
                   </p>
                   <button
                     className="text-xl text-gray-500"
                     onClick={() => setSelectedProduct(null)}
                   >
                     <LiaTimesSolid />
                   </button>
                 </div>
     
     
                 {/* Horizontal divider */}
                 <div className="w-full h-px bg-gray-400"></div>
                 <div className="relative flex-1 py-3 pl-10 pr-3 overflow-y-auto">
                   {/* Product Image Slider */}
                   <Swiper
                     slidesPerView={2.5}
                     spaceBetween={10}
                     loop={selectedProduct.images && selectedProduct.images.length > 2}
                     pagination={{ clickable: true }}
     
                     className="mt-3 mb-3"
                   >
                     {selectedProduct.images && selectedProduct.images.length > 0 ? (
                       selectedProduct.images.map((image, index) => (
                         <SwiperSlide key={index}>
                           <img
                             src={image}
                             alt={`${selectedProduct.name} ${index + 1}`}
                             className="object-cover w-full h-72 "
                           />
                         </SwiperSlide>
                       ))
                     ) : (
                       <SwiperSlide>
                         <img
                           src="https://placehold.co/600x400"
                           alt="No image available"
                           className="object-cover w-full rounded-lg h-60"
                         />
                       </SwiperSlide>
                     )}
                   </Swiper>
     
                   <h2 className="text-lg font-bold truncate">{selectedProduct.name}</h2>
                   <p className="mt-2 text-gray-600 truncate">{selectedProduct.description}</p>
                   <div className="flex items-center justify-start mt-1">
                     <span className="mr-3 text-lg font-semibold">
                       {`Rs. ${
  selectedSizePrice
    ? selectedSizePrice
    : selectedProduct.offerPrice
}`}

                     </span>
                     {selectedProduct.discount &&
                       parseFloat(selectedProduct.discount.replace("% off", "")) >
                       0 && (
                         <span className="text-sm text-gray-500 line-through">
                           {selectedProduct.originalPrice}
                         </span>
                       )}
                   </div>
     
                   {/* Size Selection */}
                   {/* SIZE SELECTION */}
{selectedProduct.sizes?.length > 0 && (
  <div className="mt-4">
    <div className="flex items-center justify-between">
      <p className="text-sm font-semibold">Select Size</p>

      {(chartImage || chartImage2) && (
        <button
          onClick={fetchSizeChart}
          className="flex items-center gap-1 text-sm underline"
        >
          <TfiRulerAlt />
          Size Chart
        </button>
      )}
    </div>

    <div className="flex flex-wrap gap-2 mt-2">
      {selectedProduct.sizes.map((sizeObj) => {
        const stock = Number(sizeObj.size_stock || 0);
        const isSelected = selectedSizeId === sizeObj.size_auto_id;

        return (
          <button
            key={sizeObj.size_auto_id}
            disabled={stock <= 0}
            className={`px-4 py-2 rounded-full border text-sm font-medium
              ${stock <= 0 ? "bg-gray-200 text-gray-400 cursor-not-allowed" : ""}
              ${isSelected ? "text-white" : "bg-white text-black"}
            `}
            style={{
              backgroundColor: isSelected ? themeColor : undefined,
              borderColor: isSelected ? themeColor : undefined,
            }}
            onClick={() => {
              setSelectedSize(sizeObj.size_name);
              setSelectedSizeId(sizeObj.size_auto_id);
              setSelectedStock(stock);

              const priceObj = selectedProduct.get_price_lists.find(
                (p) => p.size_auto_id === sizeObj.size_auto_id
              );

              if (!priceObj?.final_size_price) {
                setMessage("Size price not available");
                clearMessage();
                return;
              }

              setSelectedSizePrice(priceObj.final_size_price);
            }}
          >
            {sizeObj.size_name}
            {stock > 0 && stock <= 5 && (
              <span className="block text-[10px] mt-1">Only {stock} left</span>
            )}
          </button>
        );
      })}
    </div>
  </div>
)}

     
     
                   <div className="relative mt-5">
     
                     {message && (
                       <div
                         className="p-2 mt-2 text-sm text-center bg-white "
                         style={{
                           color: message.includes("successfully") ? "green" : "red",
                         }}
                       >
                         {message}
                       </div>
                     )}
                     {/* Flex container for quantity control and add to cart button */}
                     <div className="flex flex-row items-center gap-1">
     
                       {/* Quantity Control */}
                       <div className="flex items-center">
                         <button
                           className="bg-white px-2 py-[12px] border-l-2 border-t-2 border-b-2 border-gray-200   rounded-l-full"
                           onClick={() => setQuantity(Math.max(1, quantity - 1))}
                         >
                           <FaMinus />
                         </button>
                         <input
                           type="number"
                           min="1"
                           value={quantity}
                           onChange={(e) => {
                             const value = Math.max(1, parseInt(e.target.value));
                             setQuantity(value);
                           }}
                           className="w-11 text-center border-t-2 border-b-2 border-gray-200  py-[8px] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none appearance-none " />
                         <button
                           className="bg-white px-2 py-[12px] border-r-2 border-t-2 border-b-2  border-gray-200 rounded-r-full"
                           onClick={() => setQuantity(quantity + 1)}
                         >
                           <FaPlus />
                         </button>
                       </div>
     
                       {/* Add to Cart Button */}
                       <button
  className={`flex-1 text-white py-[12px] rounded-full border
    ${
      selectedProduct.sizes?.length > 0 && (!selectedSize || selectedStock === 0)
        ? "bg-gray-400 cursor-not-allowed"
        : "cursor-pointer"
    }
  `}
  style={{
    backgroundColor:
      selectedProduct.sizes?.length > 0 && (!selectedSize || selectedStock === 0)
        ? "#ccc"
        : themeColor,
  }}
  onClick={async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMessage(null);

    const moq = parseInt(selectedProduct?.moq || "1", 10);
    const qty = parseInt(quantity, 10);

    // ✅ SIZE REQUIRED ONLY IF SIZES EXIST
    if (
      selectedProduct.sizes?.length > 0 &&
      (!selectedSize || !selectedSizePrice)
    ) {
      setMessage("Please select a size");
      clearMessage();
      return;
    }

    if (selectedProduct.sizes?.length > 0 && selectedStock === 0) {
      setMessage("Selected size is out of stock");
      clearMessage();
      return;
    }

    if (qty < moq) {
      setMessage(`Minimum order quantity is ${moq}`);
      clearMessage();
      return;
    }

    const payload = {
      product_auto_id: selectedProduct.id,
      added_by_id: selectedProduct.user_auto_id,
      cart_quantity: qty,
      ...(selectedProduct.sizes?.length > 0 && {
        size: selectedSizeId,
        size_price: selectedSizePrice,
      }),
    };

    try {
      const res = await addToCart(payload);
      await getCartCount();

      if (res?.status === "1") {
        setMessage(res.message);
        clearMessage();
        setTimeout(() => navigate("/cart"), 800);
      } else {
        setMessage(res.message);
        clearMessage();
      }
    } catch (error) {
      setMessage(error.message);
      clearMessage();
    }
  }}
>
  {selectedProduct.sizes?.length === 0
    ? `Add to Cart | ₹ ${selectedProduct.offerPrice}`
    : !selectedSize
      ? "SELECT A SIZE"
      : selectedStock === 0
        ? "Size Out of Stock"
        : `Add to Cart | ₹ ${selectedSizePrice}`}
</button>

                     </div>
     
     
                     <div className="mt-4 text-center">
                       <Link
                         to={`/product-detail/${selectedProduct.productAutoId}`}
                         className="text-inherit"
                       >
                         <button className="text-black underline ">View Details</button>
                       </Link>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           )}

    </>
  );
};

export default Product4;